import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ProductCard = ({ product, onAddToCart }) => {
  const [status, setStatus] = useState('idle'); // idle, loading, success

  const handleAdd = (e) => {
    e.preventDefault();
    if (status !== 'idle') return;
    
    setStatus('loading');
    setTimeout(() => {
      onAddToCart(product);
      setStatus('success');
      setTimeout(() => setStatus('idle'), 2000);
    }, 600); // Simulate brief processing time
  };

  return (
    <motion.div 
      whileHover={{ y: -8 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="group cursor-pointer flex flex-col h-full focus-within:ring-2 focus-within:ring-jade focus-within:ring-offset-4 rounded-sm outline-none"
      tabIndex={0}
    >
      <div className="relative overflow-hidden aspect-[3/4] mb-6 bg-tea-stone rounded-sm">
        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
          loading="lazy"
        />
        
        <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" aria-hidden="true" />
        
        <div className="absolute bottom-0 left-0 w-full p-4 translate-y-full group-hover:translate-y-0 focus-within:translate-y-0 transition-transform duration-500 ease-out">
          <button 
            onClick={handleAdd}
            disabled={status !== 'idle'}
            className={`w-full py-3.5 uppercase text-[10px] font-bold tracking-[0.2em] transition-all flex items-center justify-center gap-2 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum-dark
              ${status === 'success' 
                ? 'bg-jade text-white' 
                : 'bg-moon-white/95 backdrop-blur-sm text-plum-dark hover:bg-jade hover:text-white'
              }`}
            aria-label={`Add ${product.name} to cart`}
            aria-live="polite"
          >
            {status === 'loading' ? (
              <SafeIcon icon={FiIcons.FiLoader} className="w-3 h-3 animate-spin" />
            ) : status === 'success' ? (
              <>
                <SafeIcon icon={FiIcons.FiCheck} className="w-3 h-3" /> Added
              </>
            ) : (
              <>
                <SafeIcon icon={FiIcons.FiPlus} className="w-3 h-3" /> Add to Cart
              </>
            )}
          </button>
        </div>
      </div>
      
      <div className="text-center flex-1 flex flex-col">
        <h3 className="font-serif text-lg md:text-xl text-gray-900 mb-2 group-hover:text-jade transition-colors duration-300">{product.name}</h3>
        <p className="text-sm text-gray-500 mb-3 italic flex-1">{product.notes}</p>
        <p className="text-jade-dark font-medium tracking-wide">${product.price}</p>
      </div>
    </motion.div>
  );
};

export default ProductCard;